import api from '@/configs/GlobalRequestHandler.js';

export default {
  signIn: (body) => {
    return api.postRequestWithBody('/login', body);
  },
  signUp: (body) => {
    return api.postRequestWithBody('/register', body);
  },
  validateUser: (token) => {
    return api.getRequest(`/user/validate/${token}`);
  },
  resetPassword: (token, body) => {
    return api.putRequestWithBody(`/reset_password/${token}`, body);
  },
  recoverPassword: (email) => {
      return api.getRequest(`/forgot_password/${email}`);
  },
  resendVerification: (email) => {
    return api.postRequestWithBody('/user/resend-verification', { email });
  },
  signIn2FA: (body) => {
    return api.postRequestWithBody('/login_2fa', body);
  },
  verifyUserByCode: (code) => {
    return api.putRequest(`/user/verify/${code}`);
  },
  validateSession: () => {
    return api.getRequest('/validate');
  },
  
  logout: () => {
    return api.postRequestWithBody('/logout', {});
  }
}
